/**
 * Home Page
 * Thin connector that wires up the ViewModel to the View
 */

import { HomeView, useHomeViewModel } from "../features/home";

export function HomePage() {
  const viewModel = useHomeViewModel();
  return <HomeView viewModel={viewModel} />;
}
